const videoProviderEnum = Object.freeze([
    {
        id: 5,
        name: "Youtube"
    },
    {
        id: 10,
        name: "Dailymotion"
    },
    {
        id: 15,
        name: "Vimeo"
    },
]);
export default videoProviderEnum;
